import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { AML_LEVEL_BASIC } from 'apps/auth/constants/Constants';
import { AML_LEVEL_FORM } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

import UsaCheckPersonalDetails from './UsaCheckPersonalDetails';
import ProfileAmlSsnSelect from '../ProfileAmlSsnSelect';

const UsaProvideSsnOrItin = (props) => {
    const { profilePurpleBlock, aml_level_name, personalSsnOrItin, personalSsnOrItinSubTitle, notNowButton, nextButton } = usePageMessages();
    const { profile_form: profile } = useExtra();
    const [showInfoPage, toggleInfoPage] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        amplitude.getInstance().logEvent('SSN ITIN Verification Entering Screen Shown');
    }, []);

    if (showInfoPage) {
        return (
            <UsaCheckPersonalDetails
                currentLevel={AML_LEVEL_BASIC}
                profilePurpleBlock={profilePurpleBlock}
                aml_level_name={aml_level_name}
                personalDetailsBlock={personalSsnOrItin}
                increase_sub_block={<DangerouslyHtml dangerouslyHtml={personalSsnOrItinSubTitle} />}
                notNowButton={notNowButton}
                nextButton={nextButton}
                onClickContinue={() => {
                    toggleInfoPage(false);
                }}
            />
        );
    }

    const redirectAfterSubmit = () => {
        if (UsaService.isUserFromFlorida(profile) || UsaService.isUserFromArizona(profile)) {
            //Refresh current page
            props.toggleSpinner(true);
            navigate(0);
        } else {
            navigate(AUTH_PROFILE_LIMITS);
        }
    };

    return (
        <CommonPage isTagA={true} backUrl={AUTH_PROFILE_LIMITS} hasBottomPanel leftCloseIcon showChat={false}>
            <ProfileAmlSsnSelect formName={AML_LEVEL_FORM} redirectAfterSubmit={redirectAfterSubmit} />
        </CommonPage>
    );
};

export default UsaProvideSsnOrItin;
